import React from "react";
import styled from "styled-components";

import a6 from "../img/amksoanim.png";

import "./topSection.css";

const TopSectionContainer = styled.div`
  position: fixed;
  z-index: 999;
  margin-top: 200px;
  margin-left: 15px;

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .icon {
    width: 62px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 18px;

    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);

    border: 1px solid rgba(255, 170, 0, 0.45);

    transition: all 0.25s ease;
    cursor: pointer;

    box-shadow:
      0 0 18px rgba(255, 170, 0, 0.65),
      0 0 40px rgba(255, 120, 0, 0.45),
      0 12px 30px rgba(0, 0, 0, 0.35);

    animation: glowPulse 2.8s infinite ease-in-out;
  }

  .icon:hover {
    transform: translateY(-6px) scale(1.1);

    box-shadow:
      0 0 28px rgba(255, 190, 0, 0.9),
      0 0 70px rgba(255, 120, 0, 0.6),
      0 25px 50px rgba(0, 0, 0, 0.45);
  }

.icon img {
  width: 42px;
  height: 42px;
  object-fit: contain;

  filter:
    drop-shadow(0 0 10px rgba(255, 170, 0, 0.8))
    drop-shadow(0 0 18px rgba(255, 120, 0, 0.6));
}
  @keyframes glowPulse {
    0% {
      box-shadow:
        0 0 14px rgba(255, 170, 0, 0.45),
        0 0 30px rgba(255, 120, 0, 0.3),
        0 12px 30px rgba(0, 0, 0, 0.3);
    }
    50% {
      box-shadow:
        0 0 22px rgba(255, 180, 0, 0.75),
        0 0 55px rgba(255, 120, 0, 0.5),
        0 18px 40px rgba(0, 0, 0, 0.35);
    }
    100% {
      box-shadow:
        0 0 14px rgba(255, 170, 0, 0.45),
        0 0 30px rgba(255, 120, 0, 0.3),
        0 12px 30px rgba(0, 0, 0, 0.3);
    }
  }
`;

export function Icons() {
  return (
    <TopSectionContainer>
      <div className="wrapper">

        <div className="icon">
          <a
            href="https://www.midrag.co.il/SpCard/Sp/81735?areaId=4&serviceId=1249&sortByCategory=569&isGeneric=false"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={a6} alt="midrag" />
          </a>
        </div>

      </div>
    </TopSectionContainer>
  );
}